import { useState, useEffect } from 'react'

const getElementByNameFromNode = (node: any, name: string) => {
    if (!node) return undefined
    const e = Object.entries(node).find(
        ([key, field]: [any, any]) => !isNaN(key) && field?.name === name,
    )?.[1]
    if (!e) return undefined
    return e as HTMLElement
}

export const useDisableCondition = (condition: string, parentNodeId = 'ad-submit-form') => {
    const [disabled, setDisabled] = useState(Boolean(condition))

    const checkCondition = (
        elementValue: string,
        compare: string,
        value: string,
        values: string[],
    ) => {
        switch (compare) {
            case '=':
                setDisabled(elementValue !== value)
                break
            case '!=':
                setDisabled(elementValue === value)
                break
            case 'LIKE':
                setDisabled(!elementValue.includes(value))
                break
            case 'NOT_LIKE':
                setDisabled(elementValue.includes(value))
                break
            case 'IN':
                setDisabled(!values.includes(elementValue))
                break
            case 'NOT_IN':
                setDisabled(values.includes(elementValue))
                break
            case 'EXISTS':
                setDisabled(!elementValue)
                break
            case 'NOT_EXISTS':
                setDisabled(Boolean(elementValue))
                break
            default:
                setDisabled(true)
        }
    }

    useEffect(() => {
        if (!condition) return

        // Get parent node
        const parentNode = document.getElementById(parentNodeId)

        // Get condition "key", "compare" and "value"
        const data = condition
            .replace(/^\s*/, '')
            .replace(/\s*$/, '')
            .replace(' ', '^')
            .replace(' ', '^')
            .split('^')
        if (data.length !== 3) return
        let [key, compare, value] = data

        // Get values in case of "IN", or "LIKE" comparison
        let values: string[] = []
        while (value.match(/[()[\]"']/)) {
            value = value.replace(/[()[\]"']/, '')
        }
        values = value.split(/\s*,\s*/)

        // Get element node to watch
        const element = getElementByNameFromNode(parentNode, key)
        if (!element) return

        // Get element target value and check if the condition is respected.
        const action = (e: any) => {
            let elementValue = e.target?.value
            if (elementValue?.includes('^')) {
                elementValue = elementValue?.split('^')[1] // in case of select option "term_ID^term_name"
            }
            checkCondition(elementValue, compare, value, values)
        }

        // Put an event listener on the watch element
        const eventType = element.tagName === 'select' ? 'change' : 'input'
        element.addEventListener(eventType, action)

        return () => {
            element?.removeEventListener(eventType, action)
        }
    }, [condition, parentNodeId])

    return disabled
}
